import { TLocalizedUrlMap } from '@internal/i18n/TLocalizedUrlMap';
import { defaultLocale } from '@internal/utils/constants';
import { TLocale } from '@internal/utils/machine/i18n/Locale';
import { MachineType } from '@internal/utils/machine/MachineType';
import { createContext, useContext } from 'react';
import { TPageData } from './TPageData';

export type PageContextProps = {
    pageData: TPageData | null;
    // biome-ignore lint/suspicious/noExplicitAny: legacy
    pathParams: any;
    machineType: MachineType | null;
    localizedUrlMap: Partial<TLocalizedUrlMap> | null;
    locale: TLocale;
};

export const PageContext = createContext<PageContextProps>({
    pageData: null,
    pathParams: {},
    machineType: null,
    localizedUrlMap: {},
    locale: defaultLocale,
});

export const usePageContext = () => useContext(PageContext);
